module.exports = __webpack_public_path__ + "img/hero_image_events.6ba889f.jpg";